import { faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { faEdit, faInfoCircle, faThumbsUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import { Location } from 'history';
import {
    number_FORUM_MESSAGES,
    number_YEARS,
    ABOUT_ME_PROFILE,
    BZ2_counter_PRODUCTS,
    EDIT_PROFILE_SETTINGS,
    FORUM_MESSAGES,
    PROFILE_MORE_ABOUT_user,
    PROFILE_REGISTERED_ON_date,
    PROFILE_VISIT_GROUP_group,
    SEND_INTERNAL_POST,
    TO_ME,
    USER_LIKE,
    USER_UNLIKE,
} from 'mk/autogenerated/translations/AboutMe.9532860f85ef83090511e98bdeb2cca6'
import { formatThousands } from 'mk/bazaar/common/formatters';
import { canManageBlogs, isAuthenticated, isAuthenticatedAs } from 'mk/bazaar/common/userUtils';
import { photoUrl } from 'mk/photo/photoUrl';
import { bazaar_single_page_seller_url, user_directory_url } from 'mk/urls/functions';
import ProfileAdminTools from 'mk2/apps/blogs/components/ProfileAdminTools';
import { ProfileDetailData } from 'mk2/apps/blogs/containers/ProfileDetail/ProfileDetail.reducers';
import { blogsProfileMoreAboutUrlNew } from 'mk2/apps/blogs/urls';
import { groupsGroupUrl } from 'mk2/apps/groups/urls';
import { mailComposeUrl } from 'mk2/apps/mail/urls';
import { SexType } from 'mk2/apps/settings/schemas';
import { settingsProfileUrl } from 'mk2/apps/settings/urls';
import { getGenericAvatar } from 'mk2/apps/users/utils';
import AmbasadorBadge from 'mk2/components/AmbasadorBadge';
import AvatarImg from 'mk2/components/AvatarImg';
import Btn, { BtnLayout, BtnType } from 'mk2/components/Btn';
import ImgVarHeight from 'mk2/components/ImgVarHeight';
import InactiveUserBadge from 'mk2/components/InactiveUserBadge';
import Link from 'mk2/components/Link';
import LoadingPlaceholder from 'mk2/components/LoadingPlaceholder';
import VerifiedOrganizationBadge from 'mk2/components/VerifiedOrganizationBadge';
import { url } from 'mk2/helpers/urls';
import { UserEntity } from 'mk2/schemas';
import { interpolate } from 'mk2/services/i18n';
import React from 'react';
import styles from './AboutMe.mscss';

interface OwnProps {
    isMobile: boolean;
    location: Location;
    moreAboutMeHasContent?: boolean;
    profileDetailData: ProfileDetailData;
    requestUser: UserEntity;
    requestUserPermissions: string[];
    onDeleteAvatarByAdmin(username: string);
    onSetLikeUser(username: string, like: boolean);
}

type Props = OwnProps;

export default class AboutMe extends React.Component<Props> {

    public render() {
        const {
            isMobile,
            moreAboutMeHasContent,
            onDeleteAvatarByAdmin,
            profileDetailData,
            requestUser,
            requestUserPermissions,
        } = this.props;

        const {
            ambassadorBrandGroupId,
            ambassadorBrandLogo,
            ambassadorBrandName,
            user,
            userAboutMeText,
            userAge,
            userAvatarPhoto,
            userIsInactive,
            userIsLiked,
            userOnlineStatus,
            userRegisteredOn,
            userResidence,
            userResidenceCountyId,
            userStats,
        } = profileDetailData;

        const isAdmin = canManageBlogs(requestUserPermissions);
        const isOwner = isAuthenticatedAs(requestUser, user);

        const avatar = (
            <div className={styles.AboutMe__avatarWrapper}>
                <div className={styles.AboutMe__avatarWrapper__avatar}>
                    <AvatarImg
                        user={user}
                        // Note: userAvatarPhoto is outside of UserEntity since UserEntity is used in mass and avatar
                        //       as PhotoEntity we need just in the Profile right now
                        // largestAvailablePhotoVersionOfPost(, '')
                        userAvatarBig={
                            userAvatarPhoto
                                ? photoUrl(userAvatarPhoto, 's1600x1600')
                                : getGenericAvatar(150, user.gender !== 'M' ? SexType.Girl : SexType.Boy)
                        }
                        size={isMobile ? 150 : 200}
                    />
                </div>
            </div>
        );

        const ambassadorPanel = (
            <div className={styles.AboutMe__details__ambassadorBanner}>
                <AmbasadorBadge
                    className={styles.AboutMe__details__ambassadorBanner__badge}
                />
                <ImgVarHeight
                    photo={ambassadorBrandLogo}
                    width={270}
                    photoVersion={'s270x100'}
                    className={styles.AboutMe__details__ambassadorBanner__image}
                />
                {ambassadorBrandGroupId && (
                    <Link
                        to={url(groupsGroupUrl, {groupId: ambassadorBrandGroupId})}
                    >
                        {interpolate(PROFILE_VISIT_GROUP_group, {group: ambassadorBrandName})}
                    </Link>
                )}
            </div>
        );

        const likeUser = (
            <div className={styles.AboutMe__details__likeUser}>
                {!userIsLiked ? (
                    <Btn
                        layout={BtnLayout.IconLabelCount}
                        type={BtnType.Blue}
                        icon={faThumbsUp}
                        label={<b>{USER_LIKE}</b>}
                        onClick={this.handleLikeUser}
                    />
                ) : (
                    <Btn
                        layout={BtnLayout.IconLabelCount}
                        type={BtnType.BlueOutline}
                        label={<b>{USER_UNLIKE}</b>}
                        onClick={this.handleUnLikeUser}
                    />
                )}
            </div>
        );

        if (!isAuthenticated(requestUser)) {
            return (
                <div className={styles.AboutMe}>
                    {avatar}
                    <div className={styles.AboutMe__details}>
                        <div className={styles.AboutMe__details__personal}>
                            <div className={styles.AboutMe__details__personal__username}>
                                {user.username}
                            </div>
                        </div>
                        {!isMobile && !isOwner && likeUser}
                        {user.isAmbassador && ambassadorPanel}
                    </div>
                </div>
            );
        }

        return (
            <>
                <div className={styles.AboutMe}>
                    {avatar}
                    <div className={styles.AboutMe__details}>
                        <div className={styles.AboutMe__details__personal}>
                            <div className={styles.AboutMe__details__personal__username}>
                                {user.username}
                            </div>
                            {(user.isVerifiedOrganization || userIsInactive) && (
                                <div className={styles.AboutMe__details__personal__badges}>
                                    {user.isVerifiedOrganization &&
                                        <VerifiedOrganizationBadge />
                                    }
                                    {userIsInactive &&
                                        <InactiveUserBadge />
                                    }
                                </div>
                            )}
                            {userAge && (
                                <div className={styles.AboutMe__details__personal__age}>
                                    {interpolate(number_YEARS, {count: userAge, number: userAge})}
                                </div>
                            )}
                        </div>

                        {!isMobile && (
                            <>
                                {!isOwner && (
                                    <>
                                        {likeUser}
                                        <div className={styles.AboutMe__details__internalPost}>
                                            <Btn
                                                layout={BtnLayout.IconLabelCount}
                                                type={BtnType.Menu}
                                                icon={faEnvelope}
                                                label={SEND_INTERNAL_POST}
                                                link={url(mailComposeUrl, {}, { to: user.username })}
                                            />
                                        </div>
                                    </>
                                )}
                                {!isMobile && isAdmin && (
                                    <div className={styles.AboutMe__profileAdminTools}>
                                        <ProfileAdminTools
                                            user={user}
                                            onlineStatus={userOnlineStatus}
                                            onDeleteAvatarByAdmin={onDeleteAvatarByAdmin}
                                        />
                                    </div>
                                )}
                                {user.isAmbassador && ambassadorPanel}
                            </>
                        )}

                        <div
                            className={cx(
                                styles.AboutMe__details__about,
                                moreAboutMeHasContent && styles['AboutMe__details__about--moreAboutMeHasContent'],
                            )}
                        >
                            {!isMobile && (
                                <>
                                    {userRegisteredOn && (
                                        /* if !userRegisteredOn is null then requestUser cannot see profile, therefore
                                        no need for header */
                                        <h2>{ABOUT_ME_PROFILE}</h2>
                                    )}
                                    {!!userAboutMeText && userAboutMeText.trim() && (
                                        <div className={styles.AboutMe__details__about__aboutMeText}>
                                            {userAboutMeText}
                                        </div>
                                    )}
                                </>
                            )}

                            {userRegisteredOn && (
                                <div className={styles.AboutMe__details__about__registeredOn}>
                                    {interpolate(PROFILE_REGISTERED_ON_date, { date: userRegisteredOn })}
                                </div>
                            )}

                            {!!userStats.forumMessagesCount && (
                                <div className={styles.AboutMe__details__about__forumMessagesCount}>
                                    {interpolate(number_FORUM_MESSAGES, {
                                        number: userStats.forumMessagesCount,
                                        count: userStats.forumMessagesCount,
                                    })} {FORUM_MESSAGES}
                                </div>
                            )}

                            {userResidence && (
                                <div className={styles.AboutMe__details__about__residence}>
                                    {userResidenceCountyId ? (
                                        <Link
                                            to={user_directory_url({county: userResidenceCountyId})}
                                        >
                                            {userResidence}
                                        </Link>
                                    ) : userResidence}
                                </div>
                            )}

                            {userStats.marketProductsCount != null && (
                                <div className={styles.AboutMe__details__about__marketproductsCount}>
                                    <Link
                                        to={bazaar_single_page_seller_url(user.username)}
                                    >
                                        {interpolate(BZ2_counter_PRODUCTS, {
                                            counter: formatThousands(userStats.marketProductsCount),
                                            count: userStats.marketProductsCount,
                                        })}
                                    </Link>
                                </div>
                            )}

                            {isMobile ? (
                                <>
                                    {user.isAmbassador && ambassadorPanel}

                                    {moreAboutMeHasContent && (
                                        <div className={styles.AboutMe__details__about__moreAboutMe}>
                                            <Link to={url(blogsProfileMoreAboutUrlNew, { username: user.username })}>
                                                <>
                                                    <FontAwesomeIcon icon={faInfoCircle} />
                                                    &nbsp;
                                                    {interpolate(PROFILE_MORE_ABOUT_user, {
                                                        user: isOwner ? TO_ME : user.username,
                                                    })}
                                                </>
                                            </Link>
                                        </div>
                                    )}
                                </>
                            ) : isOwner && (
                                <div>
                                    <Btn
                                        icon={faEdit}
                                        label={EDIT_PROFILE_SETTINGS}
                                        link={url(settingsProfileUrl, { username: user.username })}
                                        sidePadding={0}
                                        type={BtnType.Link}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {isMobile && isAdmin && (
                    <div className={styles.AboutMe__profileAdminTools}>
                        <ProfileAdminTools
                            user={user}
                            onlineStatus={userOnlineStatus}
                            onDeleteAvatarByAdmin={onDeleteAvatarByAdmin}
                        />
                    </div>
                )}
            </>
        );
    }

    private handleLikeUser = () => {
        const { profileDetailData, onSetLikeUser } = this.props;
        if (!!profileDetailData && profileDetailData.user) {
            onSetLikeUser(profileDetailData.user.username, true);
        }
    };

    private handleUnLikeUser = () => {
        const { profileDetailData, onSetLikeUser } = this.props;
        if (!!profileDetailData && profileDetailData.user) {
            onSetLikeUser(profileDetailData.user.username, false);
        }
    };
}

interface PlaceholderOwnProps {
    isMobile: boolean;
    username: string;
}

export const AboutMePlaceholder = React.memo<PlaceholderOwnProps>(({ isMobile, username }) => {
    return (
        <>
            <div className={styles.AboutMe}>
                <div className={styles.AboutMe__avatarWrapper}>
                    <div className={styles.AboutMe__avatarWrapper__avatar}>
                        <LoadingPlaceholder width={isMobile ? 150 : 200} height={isMobile ? 150 : 200} />
                    </div>
                </div>
                <div className={styles.AboutMe__details}>
                    <div className={styles.AboutMe__details__personal}>
                        <div className={styles.AboutMe__details__personal__username}>
                            {username}
                        </div>
                        <LoadingPlaceholder width={170} height={isMobile ? 55 : 90} style={{ marginTop: 20}}  />
                        <LoadingPlaceholder width={isMobile ? 170 : 296} height={isMobile ? 34 : 500} style={{ marginTop: 10}}  />
                    </div>
                </div>
            </div>
        </>
    );
});

AboutMePlaceholder.displayName = 'AboutMePlaceholder';
